import { Route } from '@angular/router';
import { CommandeLingeriesEditComponent } from './commande-lingeries-edit.component';

export const CommandeLingeriesEditRouting: Route = {
  path: "edit-commande",
  component: CommandeLingeriesEditComponent,
  data: {
    breadcrumb: "Gestion de la commande"
  }
}
